import { Menu, X } from "lucide-react"
import {
  aIsCaptionsOpen,
  aIsMobileMenuOpen,
  aIsQualityOpen,
  aIsSpeedOpen,
  useAtom,
  useAtomValue,
} from "~/atoms"
import { Tooltip } from "~/components/ui"
import { ControlButton } from "./control-button"

export default function MenuButton({ className }: { className?: string }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useAtom(aIsMobileMenuOpen)
  const isSpeedOpen = useAtomValue(aIsSpeedOpen)
  const isQualityOpen = useAtomValue(aIsQualityOpen)
  const isCaptionsOpen = useAtomValue(aIsCaptionsOpen)

  const anyPopoverOpen = isSpeedOpen || isQualityOpen || isCaptionsOpen

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    if (!anyPopoverOpen) {
      setIsMobileMenuOpen(!isMobileMenuOpen)
    }
  }

  return (
    <Tooltip.Provider>
      <Tooltip delayDuration={200}>
        <Tooltip.Trigger asChild>
          <ControlButton
            className={className}
            onClick={handleClick}
            aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
          >
            {isMobileMenuOpen ? (
              <X className="h-6 w-6 text-white" />
            ) : (
              <Menu className="h-6 w-6 text-white" />
            )}
          </ControlButton>
        </Tooltip.Trigger>
        <Tooltip.Content>
          {isMobileMenuOpen ? "Close menu" : "Open menu"}
        </Tooltip.Content>
      </Tooltip>
    </Tooltip.Provider>
  )
}
